import { Button } from '@coconut-software/ui';
import type { FC } from 'react';
import React, { useEffect, useState } from 'react';
import { DEFAULT_ERROR_IMAGE, ERROR_IMAGES } from '../constants';
import { decodeHtmlEntities } from '../helpers/Html';

interface ErrorMessageProps {
  code: number;
  message: string;
  backButtonLabel?: string;
  details?: string;
  showBackButton?: boolean;
  columnLayout?: boolean;
}

const ErrorMessage: FC<ErrorMessageProps> = ({
  code,
  message,
  backButtonLabel = 'Go Back',
  details = null,
  showBackButton = true,
  columnLayout = false,
}) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (code) {
      setImageSrc(ERROR_IMAGES[code] ?? DEFAULT_ERROR_IMAGE);
    }
  }, [code]);

  return (
    <div
      className={`flex flex-col justify-center items-center h-screen xl:gap-10 px-8 xl:px-40 max-w-400 m-auto ${
        columnLayout ? '' : 'xl:flex-row'
      }`}
    >
      <div className="max-w-90 lg:max-w-120">
        <img
          alt=""
          id={`${code}-error-image`}
          src={`/${imageSrc}`}
          width="100%"
        />
      </div>
      <div
        className={`max-w-96 lg:max-w-120 mt-6 ${
          columnLayout ? '' : 'xl:mt-0'
        }`}
      >
        <h1
          className={`text-2xl md:text-4xl leading-none ${
            columnLayout ? '' : 'xl:max-w-96'
          }`}
        >
          {decodeHtmlEntities(message)}
        </h1>
        <div className="mt-6">
          <h2 className={`text-gray-600 text-lg md:text-2xl`}>
            {decodeHtmlEntities(code + (details ? `: ${details}` : ''))}
          </h2>
        </div>
        {showBackButton ? (
          <div className="mt-6">
            <Button onClick={() => history.back()}>{backButtonLabel}</Button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ErrorMessage;
